import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import tick from '../../assets/img/tick.png';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: 24,
};

function OrderSuccessModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const handleDoneClick = () => {
    onClose();
    navigate("/"); 
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="add-item-modal-title"
      aria-describedby="add-item-modal-description"
    >
      <Box sx={style}>
        {/* Modal Header */}
        <Box
          sx={{
            backgroundColor: "#2196F3", // blue background like in the image
            padding: "20px",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <Typography id="add-item-modal-title" variant="h6" component="h2">
            Order placed
          </Typography>
        </Box>

        {/* Modal Body */}
        <Box sx={{ padding: "40px", textAlign: "center" }}>
          {/* Success Icon */}
          <Box
            sx={{
              width: "100px",
              height: "100px",
              backgroundColor: "green",
              borderRadius: "50%",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={tick} alt="Success" style={{ width: "60px", height: "60px" }} />
          </Box>

          <Typography
            sx={{
              marginTop: "20px",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            Order placed Successfully!
          </Typography>

          {/* Done Button */}
          <Button
            onClick={handleDoneClick} // Call the new handler
            variant="contained"
            sx={{
              marginTop: "20px",
              backgroundColor: "#2196F3",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#1976D2",
              },
            }}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default OrderSuccessModal;
